<template>
  <div style="padding: 35px 30px;"> 
      <p>Uma vez que não se faz necessária a autorização do uso dos dados pessoais, para cumprimento de obrigação legal, a LGPD não tem maiores particularidades no setor fiscal das empresas, conforme art. 7º, II da LGPD. No entanto, as Secretarias da Fazenda dos Estados deverão adaptar-se as exigências da LGPD, para o tratamento dos dados pessoais exigidos em seus registros.</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>